import * as React from 'react';
import { FollowedArticlesComp } from './followed-articles';

export const FollowedArticles = ({ model, locale }) => (props) => {
  return <FollowedArticlesComp locale={locale} articles={model.followingArticles} />;
};
